module.exports = __webpack_public_path__ + "static/media/information-icon.8052a69d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/information-icon.svg
// module id = 462
// module chunks = 0